import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const ButtonWrapper = styled.button`
  padding: 0px 32px;
  margin: 0px;
  border-radius: 500px;
  color: rgb(255, 255, 255);
  background: rgb(0, 30, 80);
  border: none;
  cursor: pointer;
  min-height: 44px;
  min-width: 44px;

  &:focus-within {
    background-color: #4cc7f4;
  }

  &:disabled {
    background-color: #c2cacf;
    color: #3c484d;
    cursor: not-allowed;
  }
`;

type ButtonProps<C extends React.ElementType> = {
  as?: C;
  children: React.ReactNode;
} & React.ComponentPropsWithRef<C>;

export const Button = <C extends React.ElementType>({children, ...restProps}: ButtonProps<C>) => {

  return <ButtonWrapper {...restProps}>{children}</ButtonWrapper>;
};